/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GetCompanyFromPortalAccountManagerDto interface.
 */
export function instanceOfGetCompanyFromPortalAccountManagerDto(value) {
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined)
        return false;
    return true;
}
export function GetCompanyFromPortalAccountManagerDtoFromJSON(json) {
    return GetCompanyFromPortalAccountManagerDtoFromJSONTyped(json, false);
}
export function GetCompanyFromPortalAccountManagerDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'phoneNumber': json['phoneNumber'],
        'profilePictureUrl': json['profilePictureUrl'] == null ? undefined : json['profilePictureUrl'],
    };
}
export function GetCompanyFromPortalAccountManagerDtoToJSON(json) {
    return GetCompanyFromPortalAccountManagerDtoToJSONTyped(json, false);
}
export function GetCompanyFromPortalAccountManagerDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'phoneNumber': value['phoneNumber'],
        'profilePictureUrl': value['profilePictureUrl'],
    };
}
